import { render, staticRenderFns } from "./NotificationEmailDay.vue?vue&type=template&id=a8907478&"
import script from "./NotificationEmailDay.vue?vue&type=script&lang=js&"
export * from "./NotificationEmailDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports